export function Dashboard() {
  return <div>SUL AI Client Dashboard</div>
}
